/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.BulkResponse,
  BulkCollection: (params: vp.BulkCollectionRequest) => void,
  BulkCollectionAsync: (params: vp.BulkCollectionRequest) => Promise<vp.BulkResponse>,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const useBulkFedwireCollection: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldBulkCollection, setShouldBulkCollection] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.BulkCollectionRequest>({
    BatchName: '',
    BatchData: {},
  });
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const [response, setResponse] = useState<vp.BulkResponse>({
    Success: false,
    ErrorMessage: '',
    BatchTransactionRequestID: '',
    TotalSubmittedTransactions: '',
    NumberOfRejectedTransactions: '',
    RejectedTransactions: '',
  });

  useEffect(() => {
    if (!shouldBulkCollection) return () => {};

    const postBulkFedwireCollection = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');
      const res = await api.postBulkFedwireCollection(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldBulkCollection) void postBulkFedwireCollection();
    setShouldBulkCollection(false);
    return () => {
      source.cancel();
    };
  }, [shouldBulkCollection]);

  return [
    response,
    (_params: vp.BulkCollectionRequest) => {
      setParams(_params);
      setShouldBulkCollection(true);
    },
    async (_params: vp.BulkCollectionRequest) => {
      const res = await api.postBulkFedwireCollection(_params, source);
      return res;
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        BatchTransactionRequestID: '',
        TotalSubmittedTransactions: '',
        NumberOfRejectedTransactions: '',
        RejectedTransactions: '',
      });
      setShouldBulkCollection(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useBulkFedwireCollection);
